import React, { FunctionComponent, memo, MouseEvent } from 'react';
import { useSelector } from 'react-redux'

import { TranslatedString } from '@bigcommerce/checkout/locale';

import { tips } from '../b3checkout/locales'

import storage from '../b3checkout/utils/storage';


export interface EditLinkProps {
    className?: string;
    url: string;
}

interface B3Store {
    global: {
        quoteId: string | number
    }
}

const EditLink: FunctionComponent<EditLinkProps> = ({ className, url }) => {
    // if there is b3 quote checkout, user cant edit cart
    const quoteCheckoutId = storage.quoteCheckoutId.getValue()

    const {
        quoteId,
    } = useSelector(({
        global: {
            quoteId
        }
    }: B3Store) => ({
        quoteId
    }))
    const b3RoleId = storage.B3RoleId.getValue()

    const IPCheckout = storage.IPCheckout.getValue() === '1'

    if (quoteCheckoutId || quoteId || b3RoleId === '2') {
        return null
    }

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        window.location.href = (window as any)?.B3?.setting?.b2b_url ? '/account.php?action=order_status/#/invoice' : '/invoices'
      };

    return (
        <>
            {
                IPCheckout ? 
                <a
                    className={className || 'cart-header-link'}
                    href="#"
                    id="cart-edit-link"
                    onClick={handleClick}
                    target="_top"
                >
                    {tips['b3.invoice.backList'] || 'Back to Invoices'}
                </a> :
                <a
                    className={className || 'cart-header-link'}
                    data-test="cart-edit-link"
                    href={url}
                    id="cart-edit-link"
                    target="_top"
                >
                    <TranslatedString id="cart.edit_cart_action" />
                </a>
            }
        </>
        
    )
};

export default memo(EditLink);
